export default {
    dashboard: {
        title: 'Pannello di controllo',
        description: 'Gestione della classifica e delle registrazioni'
    },
    login: {
        title: 'Login',
        description: 'Login'
    },
    home: {
        title: 'Sito pubblico',
        description: 'La classifica come la vedono i partecipanti'
    },
    customers: {
        title: 'Clienti',
        description: 'Panoramica completa dei clienti'
    },
    notFound: {
        title: '404',
        description: 'Pagina non trovata'
    }
}